import _ from 'underscore';
import moment from 'moment';
import AssetPickerTypes from '~/components/common/asset-picker/asset-picker-types';
import { ContentIcon } from '~/features/common';
import LearningObjectIcon from '../../components/common/asset-picker/LearningObjectIcon';
import AdminIndexActions from './admin-index-actions';

const AdminIndexFormatters = {
  formatAcademyCertification: (result) =>
    AdminIndexFormatters.formatResult(result, AssetPickerTypes.ACADEMY_CERTIFICATION),
  formatAcademyCollection: (result) => AdminIndexFormatters.formatResult(result, AssetPickerTypes.ACADEMY_COLLECTION),
  formatAcademyPath: (result) => AdminIndexFormatters.formatResult(result, AssetPickerTypes.ACADEMY_PATH),
  formatAcademyEvent: (result) => AdminIndexFormatters.formatResult(result, AssetPickerTypes.ACADEMY_EVENT),

  formatCourseResult: (result) => AdminIndexFormatters.formatResult(result, 'Guide'),

  formatChallengeResult: (result) => AdminIndexFormatters.formatResult(result, 'Challenge'),

  formatEventResult: (result) => AdminIndexFormatters.formatResult(result, 'Event'),

  formatFolderResult: (result) => {
    const snippetResult = result._snippetResult;
    const name = snippetResult && snippetResult.name ? snippetResult.name.value : result.name;

    return {
      icon: <LearningObjectIcon type={AssetPickerTypes.FOLDER} />,
      name,
      onSelect: AdminIndexActions.folderAction.bind(this, result),
      searchResult: result,
      type: AssetPickerTypes.FOLDER,
    };
  },

  formatPathResult: (result) => AdminIndexFormatters.formatResult(result, AssetPickerTypes.SERIES),

  formatResourceResult: (result) => AdminIndexFormatters.formatResult(result, 'Resource'),

  formatUniversityResult: (result) => {
    const TRANSLATED_UNIVERSITY_TYPE_DISPLAY_NAME = I18n.t('common.content.university', { count: 1 });

    return AdminIndexFormatters.formatResult(result, TRANSLATED_UNIVERSITY_TYPE_DISPLAY_NAME);
  },

  formatWorkflowResult: (result) => AdminIndexFormatters.formatResult(result, 'Workflow'),

  formatTopLevelContentResult: (result) => {
    if (_.contains(APP_CONSTANTS.TOP_LEVEL_CONTENT_UNSEARCHABLE_FOR_ADMINS, result.type)) {
      return null;
    }

    return AdminIndexFormatters.formatResult(result, result.type, result.content_source);
  },
};

AdminIndexFormatters.formatResult = (result, type, subType) => {
  const snippetResult = result._snippetResult;
  const name = snippetResult && snippetResult.name ? snippetResult.name.value : result.name;
  const matchedTagContent = AdminIndexFormatters._getTags(result);

  return {
    icon: <ContentIcon type={type} subType={subType} />,
    name,
    onSelect: AdminIndexActions.contentAction.bind(this, result),
    type,
    subType,
    matchedTagContent,
    content: `Updated ${moment(result.updated_at).format('MMM D YYYY')}`,
    searchResult: result,
    lastUpdatedBy: result.last_updated_by_name,
  };
};

AdminIndexFormatters._getTags = function (result) {
  const snippetResult = result._snippetResult;
  const tags = snippetResult ? snippetResult.object_tags : null;
  if (tags) {
    const matchedTags = _.filter(tags, (tag) => AdminIndexFormatters._isMatch(tag));
    return _.map(matchedTags, (tag, idx) => {
      // add space to all tags after the first, as we directly display this via dangerouslySetInnerHTML
      if (idx !== 0) return ` ${tag.value}`;
      return tag.value;
    });
  }
};

AdminIndexFormatters._isMatch = function (snippet) {
  return snippet && snippet.matchLevel !== 'none';
};

AdminIndexFormatters.formatAdminResult = (result) => {
  if (_.contains(APP_CONSTANTS.GENERIC_TOP_LEVEL_CONTENT_TYPES, result.type)) {
    return AdminIndexFormatters.formatTopLevelContentResult(result);
  }

  switch (result.type) {
    case AssetPickerTypes.CLASS:
      return AdminIndexFormatters.formatEventResult(result);
    case AssetPickerTypes.FOLDER:
      return AdminIndexFormatters.formatFolderResult(result);
    case AssetPickerTypes.WORKFLOW:
      return AdminIndexFormatters.formatWorkflowResult(result);
    case AssetPickerTypes.GUIDE:
      return AdminIndexFormatters.formatCourseResult(result);
    case AssetPickerTypes.GUIDE_TASK:
      return null;
    case AssetPickerTypes.GUIDE_SECTION:
      return null;
    case AssetPickerTypes.CHALLENGE:
      return AdminIndexFormatters.formatChallengeResult(result);
    case AssetPickerTypes.SERIES:
      return AdminIndexFormatters.formatPathResult(result);
    case AssetPickerTypes.RESOURCE:
      return AdminIndexFormatters.formatResourceResult(result);
    case AssetPickerTypes.UNIVERSITY:
      return AdminIndexFormatters.formatUniversityResult(result);
    case AssetPickerTypes.ACADEMY_CERTIFICATION:
      return AdminIndexFormatters.formatAcademyCertification(result);
    case AssetPickerTypes.ACADEMY_PATH:
      return AdminIndexFormatters.formatAcademyPath(result);
    case AssetPickerTypes.ACADEMY_COLLECTION:
      return AdminIndexFormatters.formatAcademyCollection(result);
    case AssetPickerTypes.ACADEMY_EVENT:
      return AdminIndexFormatters.formatAcademyEvent(result);
    default:
      console.log('Received an invalid search item.');
  }
};

export default AdminIndexFormatters;
